'use client';

import { useQuery } from '@tanstack/react-query';
import * as authService from '@/lib/services/auth';
import { queryKeys } from '@/lib/queryKeys';
import { getApiErrorMessage } from '@/lib/apiError';

/**
 * Verifies (and renews) an existing cookie session via refresh.
 * This is used as a lightweight "am I authenticated" probe.
 */
export function useAuthSession() {
  const query = useQuery({
    queryKey: queryKeys.auth.session(),
    queryFn: () => authService.refresh(),
    staleTime: Infinity,
    gcTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    ...query,
    errorMessage: getApiErrorMessage(query.error),
  };
}

